import {
    AdminRole,
    External_Attendee_Role,
    GuestRole,
    OwnerRole,
} from '../../enums/users';

export const canRespondToNirovisionAccessRequests = (role?: string) => {
    const roleStr = String(role ?? '').toLowerCase();
    return (
        roleStr === GuestRole.Admin ||
        roleStr === GuestRole.DepartmentAdmin ||
        roleStr === GuestRole.User ||
        roleStr === External_Attendee_Role.User
    );
};

export const canViewNirovisionAccessRequests = (role?: string) => {
    const roleStr = String(role ?? '').toLowerCase();
    return (
        canRespondToNirovisionAccessRequests(role) ||
        roleStr === AdminRole.Admin ||
        roleStr === OwnerRole.Admin ||
        roleStr === OwnerRole.User
    );
};

export const splitIdentityName = (name?: string) => {
    const parts = (name || '').trim().split(/\s+/).filter(Boolean);
    return {
        firstName: parts[0] || '',
        lastName: parts.slice(1).join(' '),
    };
};
